import { render } from "./ProjectPreview.vue?vue&type=template&id=51585a85"
import script from "./ProjectPreview.vue?vue&type=script&lang=js"
export * from "./ProjectPreview.vue?vue&type=script&lang=js"

import "./ProjectPreview.vue?vue&type=style&index=0&id=51585a85&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__